import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Conteúdo legal fixo (não editorial), i18n de UI padrão — segue o mesmo layout das demais
// páginas institucionais públicas (section-padding/container-custom/card do design system).
const Privacidade: React.FC = () => {
  const { t } = useTranslation();
  const updatedAt = new Date('2026-09-26').toLocaleDateString();

  return (
    <div className="min-h-screen">
      <section className="section-padding bg-gray-50">
        <div className="container-custom max-w-3xl">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-primary-600 mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            {t('testimonials.backHome')}
          </Link>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('privacyPage.title')}</h1>
          <p className="text-sm text-gray-500 mb-8">{t('privacyPage.updatedAt', { date: updatedAt })}</p>

          <div className="card space-y-6 text-gray-700">
            <p>{t('privacyPage.intro')}</p>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacyPage.dataCollectedTitle')}</h2>
              <p>{t('privacyPage.dataCollected')}</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacyPage.cookiesTitle')}</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>{t('privacyPage.cookiesNecessary')}</li>
                <li>{t('privacyPage.cookiesAnalytics')}</li>
                <li>{t('privacyPage.cookiesMarketing')}</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacyPage.rightsTitle')}</h2>
              <p>{t('privacyPage.rights')}</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacyPage.contactTitle')}</h2>
              <p>
                {t('privacyPage.contact')}{' '}
                <Link to="/contato" className="text-primary-600 hover:text-primary-700 underline">
                  {t('footer.contact')}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacidade;
